import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import PublicInstallPage from '@/pages/PublicInstallPage/PublicInstallPage';

// https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <StrictMode>
    <PublicInstallPage />
  </StrictMode>,
);
